import * as React from "react";
import { FC } from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { TitleMelCategoryCustomer } from "./Constant/Source";
import MelCategoryCustomerCreateForm from "./Forms/MelCategoryCustomerCreateForm";

const MelCategoryCustomerCreate: FC<CreateProps> = props => {
  return (
    <Create {...props} title={TitleMelCategoryCustomer.create}>
      <SimpleForm>
        <MelCategoryCustomerCreateForm />
      </SimpleForm>
    </Create>
  );
};

export default MelCategoryCustomerCreate;
